<template>
  <div class="ap-sub-panel">
    <div class="ap-query-row">
      <el-form :model="ciQuery" label-position="left" label-width="150px" class="ap-query" inline @keyup.enter.native="searchCi">
        <el-form-item label="Device Name / Model" style="margin-right: 18px">
          <el-input clearable size="small" v-model="ciQuery.deviceNameModel" placeholder="Please input" style="width:180px"></el-input>
        </el-form-item>
        <el-form-item label="Under Warranty" label-width="110px">
          <el-select clearable size="small" v-model="ciQuery.underWarranty" placeholder="Please select" style="width:180px">
            <el-option label="Yes" :value="true"></el-option>
            <el-option label="No" :value="false"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div class="ap-query-actions">
        <el-button type="primary" size="small" @click="searchCi">Search</el-button>
        <el-button size="small" @click="resetCi">Reset</el-button>
        <el-button size="small" :loading="ciExportLoading" @click="exportCi">Export</el-button>
        <el-button v-if="hasOperationPermission" type="primary" size="small" @click="addCi">+ Add</el-button>
      </div>
    </div>
    <el-table :data="ciTableData" size="small" border style="width:100%" :header-cell-style="{background:'#F5F5F9'}" @sort-change="ciSortChange" v-loading="ciLoading">
      <el-table-column label="No" width="65" align="center">
        <template slot-scope="scope">{{ (ciPage - 1) * ciPageSize + scope.$index + 1 }}</template>
      </el-table-column>
      <el-table-column prop="deviceNameModel" label="Device Name / Model" min-width="220" sortable="custom" align="left" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="deviceQuantity" label="Device Quantity" min-width="155" sortable="custom" align="center"></el-table-column>
      <el-table-column prop="underWarranty" label="Under Warranty" min-width="155" sortable="custom" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.underWarranty !== null && scope.row.underWarranty !== undefined && scope.row.underWarranty !== ''" :class="['ap-tag', 'ap-tag-' + warrantyTagClass(scope.row.underWarranty)]">{{ scope.row.underWarranty === true ? 'Yes' : 'No' }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="updatedBy" label="Modifier" min-width="130" sortable="custom" align="center"></el-table-column>
      <el-table-column prop="updatedTime" label="Modified Time" min-width="150" sortable="custom" align="center"></el-table-column>
      <el-table-column v-if="hasOperationPermission" label="Operation" width="170" align="center" fixed="right">
        <template slot-scope="scope">
          <el-button type="primary" size="mini" @click="modifyCi(scope.row)">Modify</el-button>
          <el-button type="danger" size="mini" @click="deleteCi(scope.row)" style="margin-left:5px">Delete</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="ap-pagination">
      <span class="ap-pagination-total">Total {{ ciTotal }}</span>
      <el-pagination small layout="prev, pager, next, sizes" :total="ciTotal" :current-page.sync="ciPage" :page-sizes="[10,20,50]" :page-size.sync="ciPageSize" @current-change="v => { ciPage = v; loadCiData() }" @size-change="v => { ciPageSize = v; ciPage = 1; loadCiData() }"></el-pagination>
    </div>

    <!-- CI Add/Modify Modal -->
    <el-dialog :title="ciDialogTitle" :visible.sync="ciDialogVisible" width="500px" custom-class="ci-dialog">
      <el-form :model="ciForm" ref="ciForm" label-position="top" label-width="150px" :rules="ciRules">
        <el-form-item label="Device Name / Model" prop="deviceNameModel">
          <el-input size="small" v-model="ciForm.deviceNameModel" placeholder="Please input" clearable></el-input>
        </el-form-item>
        <el-form-item label="Device Quantity">
          <el-input size="small" v-model.number="ciForm.deviceQuantity" type="number" placeholder="Please input" style="width:100%" clearable></el-input>
        </el-form-item>
        <el-form-item label="Under Warranty">
          <el-select size="small" v-model="ciForm.underWarranty" placeholder="Please select" style="width:100%" clearable>
            <el-option label="Yes" :value="true"></el-option>
            <el-option label="No" :value="false"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button size="small" @click="ciDialogVisible = false">Cancel</el-button>
        <el-button type="primary" size="small" :loading="ciSaving" @click="saveCi" style="margin-left: 6px">Save</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'AccountProfileCompetitorInfo',
  props: {
    accountInfo: { type: Object, default: () => ({}) },
    hasOperationPermission: { type: Boolean, default: false }
  },
  data() {
    return {
      ciQuery: { deviceNameModel: '', underWarranty: '' },
      ciTableData: [],
      ciLoading: false,
      ciTotal: 0,
      ciPage: 1,
      ciPageSize: 10,
      ciSortField: '',
      ciSortOrder: '',
      ciExportLoading: false,
      ciDialogVisible: false,
      ciDialogTitle: 'Add',
      ciEditId: null,
      ciSaving: false,
      ciForm: { deviceNameModel: '', deviceQuantity: '', underWarranty: '' },
      ciRules: { deviceNameModel: [{ required: true, message: 'Please enter Device Name / Model', trigger: 'blur' }] },
    }
  },
  created() {
    this.loadCiData()
  },
  watch: {
    'accountInfo.id'(newVal) {
      if (newVal) this.loadCiData()
    }
  },
  methods: {
    loadData() {
      this.loadCiData()
    },
    warrantyTagClass(v) { return v === true ? 'green' : (v === false ? 'red' : '') },
    _sortFieldMap(prop) {
      const map = { deviceNameModel: 'deviceNameModel', deviceQuantity: 'deviceQuantity', underWarranty: 'underWarranty', updatedBy: 'updatedBy', updatedTime: 'updatedTime' }
      return map[prop] || prop
    },
    loadCiData() {
      const id = this.accountInfo.id
      if (!id) return
      let params = {
        pageNum: this.ciPage,
        pageSize: this.ciPageSize,
        deviceNameModel: this.ciQuery.deviceNameModel || undefined,
        underWarranty: this.ciQuery.underWarranty !== '' ? this.ciQuery.underWarranty : undefined,
        sortField: this.ciSortField ? this._sortFieldMap(this.ciSortField) : undefined,
        sortOrder: this.ciSortOrder === 'ascending' ? 'asc' : (this.ciSortOrder === 'descending' ? 'desc' : undefined),
      }
      Object.keys(params).forEach(key => { if (params[key] === undefined || params[key] === '') delete params[key] })

      this.ciLoading = true
      let url = `${this.$store.state.islhurl}valued-account/profile/${id}/competitors`
      this.$axios.get(url, { params }).then(res => {
        this.ciLoading = false
        const data = res.data
        if (data.code === 200) {
          this.ciTableData = data.data || []
          this.ciTotal = data.totalSize || 0
        } else {
          this.ciTableData = []
          this.ciTotal = 0
          this.$message.error(data.msg || 'Failed!')
        }
      }).catch(() => {
        this.ciLoading = false
        this.ciTableData = []
        this.ciTotal = 0
      })
    },
    searchCi() {
      this.ciPage = 1
      this.loadCiData()
    },
    resetCi() {
      this.ciQuery = { deviceNameModel: '', underWarranty: '' }
      this.ciSortField = ''
      this.ciSortOrder = ''
      this.ciPage = 1
      this.loadCiData()
    },
    ciSortChange({ prop, order }) {
      this.ciSortField = order ? (prop || '') : ''
      this.ciSortOrder = order || ''
      this.ciPage = 1
      this.loadCiData()
    },
    addCi() {
      this.ciEditId = null
      this.ciDialogTitle = 'Add Competitor Info'
      this.ciForm = { deviceNameModel: '', deviceQuantity: '', underWarranty: '' }
      this.ciDialogVisible = true
      this.$nextTick(() => this.$refs.ciForm && this.$refs.ciForm.clearValidate())
    },
    modifyCi(row) {
      this.ciEditId = row.id
      this.ciDialogTitle = 'Modify Competitor Info'
      this.ciForm = { deviceNameModel: row.deviceNameModel, deviceQuantity: row.deviceQuantity, underWarranty: row.underWarranty }
      this.ciDialogVisible = true
      this.$nextTick(() => this.$refs.ciForm && this.$refs.ciForm.clearValidate())
    },
    saveCi() {
      this.$refs.ciForm.validate(valid => {
        if (!valid) return
        const id = this.accountInfo.id
        this.ciSaving = true
        let url = `${this.$store.state.islhurl}valued-account/profile/${id}/competitors`
        let method = 'post'
        if (this.ciEditId) {
          url += `/${this.ciEditId}`
          method = 'put'
        }
        this.$axios({ url, method, data: { deviceNameModel: this.ciForm.deviceNameModel, deviceQuantity: this.ciForm.deviceQuantity, underWarranty: this.ciForm.underWarranty } }).then(res => {
          this.ciSaving = false
          const data = res.data
          if (data.code === 200) {
            this.$message.success('Saved successfully!')
            this.ciDialogVisible = false
            this.loadCiData()
          } else {
            this.$message.error(data.msg || 'Save failed!')
          }
        }).catch(() => {
          this.ciSaving = false
          this.$message.error('Save failed!')
        })
      })
    },
    deleteCi(row) {
      this.$confirm('Confirm to delete this item?', 'Confirm', { type: 'warning' }).then(() => {
        const id = this.accountInfo.id
        let url = `${this.$store.state.islhurl}valued-account/profile/${id}/competitors/${row.id}`
        this.$axios.delete(url).then(res => {
          const data = res.data
          if (data.code === 200) {
            this.$message.success('Deleted successfully!')
            this.ciPage = 1
            this.loadCiData()
          } else {
            this.$message.error(data.msg || 'Delete failed!')
          }
        }).catch(() => { this.$message.error('Delete failed!') })
      }).catch(() => {})
    },
    exportCi() {
      const id = this.accountInfo.id
      if (!id) return
      this.ciExportLoading = true
      let params = {
        deviceNameModel: this.ciQuery.deviceNameModel || undefined,
        underWarranty: this.ciQuery.underWarranty !== '' ? this.ciQuery.underWarranty : undefined,
      }
      Object.keys(params).forEach(key => { if (params[key] === undefined || params[key] === '') delete params[key] })
      this.$axios({
        url: `${this.$store.state.islhurl}valued-account/profile/${id}/competitors/export`,
        method: 'get',
        params,
        responseType: 'blob'
      }).then(response => {
        this.ciExportLoading = false
        const blob = new Blob([response.data])
        const aEle = document.createElement('a')
        const href = window.URL.createObjectURL(blob)
        aEle.href = href
        aEle.download = 'CompetitorInfo_' + new Date().toISOString().slice(0, 10) + '.xlsx'
        document.body.appendChild(aEle)
        aEle.click()
        document.body.removeChild(aEle)
        window.URL.revokeObjectURL(href)
      }).catch(() => {
        this.ciExportLoading = false
        this.$message.error('Export failed!')
      })
    },
  },
}
</script>

<style lang="less" scoped>
.ap-sub-panel {
  .ap-query-row {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    flex-wrap: wrap;
    margin-bottom: 8px;
    .ap-query {
      flex: 1;
      /deep/ .el-form-item { margin-bottom: 0; }
      /deep/ .el-form-item__label { font-size: 13px; color: #1F2937; }
      /deep/ .el-form-item__content .el-input__suffix {
        left: auto;
        right: 10px;
      }
    }
    .ap-query-actions {
      display: flex;
      align-items: center;
      gap: 8px;
      padding-top: 4px;
      white-space: nowrap;
    }
  }
  .ap-tag {
    display: inline-block;
    padding: 2px 8px;
    border-radius: 3px;
    font-size: 12px;
    line-height: 20px;
    &.ap-tag-green { color: #52C41A; }
    &.ap-tag-blue { color: #1890FF; }
    &.ap-tag-orange { color: #FA8C16; }
    &.ap-tag-red { color: #F5222D; }
    &.ap-tag-gray { color: #8C8C8C; }
  }
  .ap-pagination {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding: 12px 0 0;
    gap: 12px;
    .ap-pagination-total {
      font-size: 13px;
      color: #6B7280;
    }
  }
}
.el-button+.el-button {
  margin-left: 0;
}
</style>

<style>
.ci-dialog .el-dialog__body {
  padding: 10px 20px;
}
.ci-dialog .el-form-item {
  margin-bottom: 0;
}
.ci-dialog .el-form-item__content .el-input__suffix {
  left: auto;
  right: 10px;
}
.ci-dialog .el-form--label-top .el-form-item__label {
  line-height: 28px;
  padding-bottom: 0;
  padding-top: 5px;
}
.ci-dialog .el-form-item__error {
  padding-top: 0;
}
</style>



// WEBPACK FOOTER //
// src/view/valuedAccountManagement/accountDetailTabs/AccountProfileCompetitorInfo.vue